import hero from "../../resources/js/module/hero";
import {initTabs} from '../../resources/js/module/tabs';
import slider from "../../resources/js/module/sliderLanding";

$(document).ready(function () {
    hero();
    initTabs();
    setTimeout(() => {
        $('.home .js-video-background iframe').attr('tabindex', -1);
    }, 2000);

    const testimonialsSlider = document.querySelectorAll(".tr-sd-reviews__slider");
    if (testimonialsSlider.length > 0) {
        slider(testimonialsSlider, {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: '.tr-sd-reviews-slider-btn--next',
                prevEl: '.tr-sd-reviews-slider-btn--prev',
            },
            pagination: {
                el: '.custom-swiper-pagination.tr-sd-reviews-slider-pagination',
                bulletClass: 'custom-swiper-pagination__bullet',
                clickable: true,
            },
        })
    }

    const videosSlider = document.querySelectorAll(".tr-latest-videos__slider");
    if (videosSlider.length > 0) {
        slider(videosSlider, {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: '.tr-latest-videos-slider-btn--next',
                prevEl: '.tr-latest-videos-slider-btn--prev',
            },
            pagination: {
                el: '.custom-swiper-pagination.tr-latest-videos-slider-pagination',
                bulletClass: 'custom-swiper-pagination__bullet',
                clickable: true,
            },

            breakpoints: {
                512: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
        })
    }
})

